import { Globe } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconGlobe12Line = createIcon(Globe, 12, "Line");
export const IconGlobe16Line = createIcon(Globe, 16, "Line");
export const IconGlobe20Line = createIcon(Globe, 20, "Line");
export const IconGlobe24Line = createIcon(Globe, 24, "Line");
export const IconGlobe32Line = createIcon(Globe, 32, "Line");
export const IconGlobe48Line = createIcon(Globe, 48, "Line");
export const IconGlobe64Line = createIcon(Globe, 64, "Line");
